/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/
import React, { useEffect } from 'react';
import EventService from '../services/events-service';


/**
 * Component that wraps the base functions for pray view.
 * @param {Object} props Properties for the component.
 * @return {Object} The view component that would be rendered.
 */
export function PrayView(props) {
  const viewName = getComponentName(props.children, props.viewName);
  const childrenElements = recursiveMap(props.children, viewName);
  /**
   * Calls the event to log view event.
   */
  useEffect(() => {
    if (props.disableEvent === null || props.disableEvent !== true) {
      EventService.logEvent('View', { view_name: viewName, url: window.location.href });
    }
    // TODO: Need to find a better way to make sure the event is not fired multiple times. 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });
  return childrenElements;
}

/**
 * Extracts the name of the component.
 * @param {Object} component The component name that needs to be returned.
 * @return {String} The name of the component.
 */
function getComponentName(component, viewName) {
  return viewName || component.displayName ||
    component.name ||
    (((component != null) && (component._source != null)) ? toTitleCase(component._source.fileName.split('/').pop().split('.')[0].replace('vw-', '').replace('-', ' ')) : null);
}

/**
 * Converts the string to title case.
 * @return {String} The converted string name.
 */
function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

/**
 * Recursively map the child items and map properties.
 * @param {Object} children Children element.
 * @param {String} viewName The name of the view.
 * @return {Object} The cloned element with updated properties. 
 */
function recursiveMap(children, viewName) {
  return React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }
    try {
      if (child.type.name === 'PrayButton' || child.type.name === 'PrayLink') {
        return React.cloneElement(child, { children: recursiveMap(child.props.children, viewName), viewName });
      } else {
        return React.cloneElement(child, { children: recursiveMap(child.props.children, viewName) });
      }
    } catch {
      return null;
    }
  });
}
